import { NgModule } from '@angular/core';
import { ButtonComponent } from './lib/button/button';
import { AccordionComponent } from './lib/accordion/accordion';
import { FooterComponent } from './lib/footer/footer';
import { HeaderNavComponent } from './lib/header-nav/header-nav';
import { SidebarComponent } from './lib/sidebar/sidebar';
import { CardComponent } from './lib/card-base/card';
import { TextInputComponent } from './lib/text-input/text-input';
import { DialogComponent } from './lib/dialog/dialog';
import { DropdownComponent } from './lib/dropdown/dropdown';

export { ButtonComponent } from './lib/button/button';
export type { ButtonVariant, ButtonSize, ButtonType } from './lib/button/button';
export { AccordionComponent } from './lib/accordion/accordion';
export type { AccordionItem, AccordionButton, AccordionVariant, NestedAccordionItem } from './lib/accordion/accordion-types';
export { FooterComponent } from './lib/footer/footer';
export type { FooterLink } from './lib/footer/footer';
export { HeaderNavComponent } from './lib/header-nav/header-nav';
export type { HeaderNavLevel, NavAction } from './lib/header-nav/header-nav';
export { SidebarComponent } from './lib/sidebar/sidebar';
export type { SidebarItem } from './lib/sidebar/sidebar';
export { CardComponent } from './lib/card-base/card';
export type { CardVariant, CardAppearance, CardRadius, CardPadding, CardOrientation, CardSize, CardHeadingLevel, CardCategoryStyle, CardIconStyle } from './lib/card-base/card';
export { RippleDirective } from './lib/card-base/ripple.directive';
export { TextInputComponent } from './lib/text-input/text-input';
export type { TextInputSize, TextInputType, TextInputLabelButton } from './lib/text-input/text-input';
export { DialogComponent } from './lib/dialog/dialog';
export type { DialogCloseReason } from './lib/dialog/dialog';
export type { DialogVariant } from './lib/dialog/dialog-types';
export { DialogService } from './lib/dialog/dialog.service';
export type { CompsychDialogConfig } from './lib/dialog/dialog.service';
export { CompsychDialogRef } from './lib/dialog/dialog-ref';
// Re-exported from CDK so opened content components can inject the data token.
export { DIALOG_DATA } from '@angular/cdk/dialog';
export { DropdownComponent } from './lib/dropdown/dropdown';
export type { DropdownSize, DropdownOption } from './lib/dropdown/dropdown-types';

@NgModule({
  imports: [
    ButtonComponent,
    AccordionComponent,
    FooterComponent,
    HeaderNavComponent,
    SidebarComponent,
    CardComponent,
    TextInputComponent,
    DialogComponent,
    DropdownComponent,
  ],
  exports: [
    ButtonComponent,
    AccordionComponent,
    FooterComponent,
    HeaderNavComponent,
    SidebarComponent,
    CardComponent,
    TextInputComponent,
    DialogComponent,
    DropdownComponent,
  ],
})
export class CompsychAngularModule {}
